module.exports = __webpack_public_path__ + "static/media/arkos2.10c234c9.jpg";